import React, { Component } from 'react'
import { Grid } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import axios from 'axios'
// import Swipe from 'react-easy-swipe';
import { Map } from 'immutable'
import ReduxToastr from 'react-redux-toastr'
import { connect } from 'react-redux'
import { getMessages, getActiveQuickReply, isBotTyping, activeGifSelector } from '../../redux'
import operations from '../../redux/operations'
import QuickReplyBanner from './QuickReplyBanner'
import ChatHistory from './ChatHistory'
import config from '../../config/directline'
import '../../App.css'
import UserInput from './UserInput'
import { getUserId, getIpAddress } from '../../redux'

import profilPic from '../../img/bot_gif/profile-pic.png';
import ReactGA from 'react-ga';


function connectToSocket(storeBotData, receiveData, conversationId, watermark) {

  const requestWithConversationId = {
    url: `https://directline.botframework.com/v3/directline/conversations/${conversationId}?watermark=${watermark}`,
    contentType: 'application/json',
    headers: { authorization: `Bearer ${config.secret}` },
    method: 'get',
    responseType: 'json',
  }

  const requestWithNoConversationId = {
    url: 'https://directline.botframework.com/v3/directline/conversations',
    contentType: 'application/json',
    headers: { authorization: `Bearer ${config.secret}` },
    method: 'post',
    responseType: 'json',
  }

  const startConversation = (res) => {
    /*console.log("res.data", res.data);*/
    storeBotData({
      conversationId: res.data.conversationId,
      sessionToken: config.secret,
    })
    let socket = new WebSocket(res.data.streamUrl)

    try {
      localStorage.setItem('conversationId', res.data.conversationId);
      localStorage.setItem('sessionToken', config.secret);
    } catch (e) {
      /*console.error('pas accès au localstorage')*/
    }

    socket.onclose = () => {
      /*console.log('socket close')*/
      socket = new WebSocket(res.data.streamUrl)
      /*console.log('new socket launched')*/
    }
    socket.onmessage = (e) => {
      /*console.log("e", JSON.parse(e.data));*/
      if (e.data) {
        receiveData(JSON.parse(e.data))
      }
    }
  }

  if (conversationId !== undefined) {
    /*console.log('there is a conversationId:', conversationId);*/
    /*if already have a conversationId, check if it is working...*/
    axios(requestWithConversationId)
    .then((res) => {
      if (res.status === 201 || res.status === 200) {
        /*console.log('request made with conversationId', res.data.conversationId, '=> status: ', res.status);*/
        /*if everything OK*/
        startConversation(res)
      }
    })
    .catch(err => {
      /*console.error("ERROR 🔥 🔥 🔥", err)*/
      /*console.log('conversationId seems to be shit, let\'get another one');*/
      throw axios(requestWithNoConversationId)
            .then((res) => {
              /*if everything OK*/
              if (res.status === 201 || res.status === 200) {
                /*console.log('there is now a conversationId', res.data.conversationId, 'status is: ', res.status);*/
                startConversation(res)
              }
            })
            .catch(err => {
              /*console.error('AGAIN 🔥 🔥', err)*/
            })
    })
    .catch(err => {
      /*console.error('init error caught 🔥', err);*/
      return  undefined;
    })
  } else {
    /*console.log('there is no conversationId');*/
    /*if no conversationId, grab one and start conversation*/
    axios(requestWithNoConversationId).then((res) => {
      /*if everything OK*/
      /*console.log('res.status', res.status);*/
      if (res.status === 201 || res.status === 200) {
        /*console.log('there is now a conversationId', res.data.conversationId, 'status is: ', res.status);*/
        startConversation(res)
      }
    })
  }
}

class App extends Component {

  constructor(props) {
      super();
      ReactGA.initialize('UA-116577900-1');
      ReactGA.pageview('intro');
      this.state = {
        alreadySeenIntro: false,
        forceIntro: false,
        width: window.innerWidth,
        height: window.innerHeight,
        lastTimeNextPage: new Date(),
        currentIntroPage: 0,
        conversationId: props.conversationId
      };

      this.handleDotClicked = this.handleDotClicked.bind(this);
  }

  componentDidMount() {
    this.scrollToBottom();
    this.launchApp()
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  launchApp() {
    const {
      storeBotData,
      receiveData,
      conversationId,
      watermark,
      getIpAddress,
      setEmotion,
    } = this.props;

    connectToSocket(storeBotData, receiveData, conversationId, watermark, setEmotion)
    getIpAddress()
    this.scrollToBottom();
    conversationId && this.skipIntro()
  }

  handleDotClicked(e) {
    this.setState({ currentIntroPage: parseInt(e.target.dataset.dot, 10)})
  }
  handlePrevClick() {
    this.setState({ currentIntroPage: this.state.currentIntroPage === 0 ? 0 : this.state.currentIntroPage - 1})
  }

  handleNextClick() {
    if (this.state.currentIntroPage === 4) {
      this.skipIntro();
    } else {
      this.setState({ currentIntroPage: this.state.currentIntroPage + 1});

    }

  }

  updateDimensions() {
      this.setState({width: window.innerWidth, height: window.innerHeight});
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log("this.props, this.state", this.props, this.state);

    if (!prevProps.conversationId && this.props.conversationId) {
      console.log('cest bueno');
      this.skipIntro();
    }

    this.secondRow && !this.state.secondRow && this.setState({ secondRow: { offsetHeight: this.secondRow.offsetHeight, offsetTop: this.secondRow.offsetTop  }})
    if (prevProps.messages.length !== this.props.messages.length) {
      this.scrollToBottom();
    // } else if {

    }
    if ((prevProps.isFetchingIpAddress && !this.props.isFetchingIpAddress) || (!prevState.secondRow && this.state.secondRow)) {
      this.scrollToBottom();
    }
  }

  scrollToBottom() {
    if (this.secondRow) {
        this.secondRow.scrollTop = this.secondRow.scrollHeight;
        const container = document.querySelector('.root__inner-container');
        container.scrollTop = container.scrollHeight;
        if (window.innerWidth < 1000) {
          window.scrollTo(0,document.body.scrollHeight);
        }
    }
  }

  skipIntro() {
    console.log('skipIntro');
    const {
      messages,
      sendMessage,
      sessionToken,
      conversationId,
      ipAddress,
      userId,
    } = this.props;

    console.log("userId", userId);

      ReactGA.pageview('chat');
      this.setState({ 
        alreadySeenIntro: true,
        forceIntro: false
      });
      this.forceUpdate();
      /*------------------------------------*/
          /*CONVERSTATION START WHEN BUTTON 'COMMENCER' CLICKED*/
      /*------------------------------------*/
      const params = {
        type: 'message',
        from: {
          id: userId,
          ipAddress
        },
      };
      let formatedMessage;
      
      if (messages.length === 0) {
         formatedMessage = { ...params, text: '/start' };
      } else {
         formatedMessage = { ...params, text: '/startagain' };
      }

      window.setTimeout(() => {
        try {
          sendMessage(localStorage.getItem('sessionToken'), formatedMessage, localStorage.getItem('conversationId'));
        } catch(e) {
          console.log("sessionToken, conversationId, userId, ipAddress", sessionToken, conversationId, userId, ipAddress);
          sendMessage(sessionToken, formatedMessage, conversationId);
        }
      }, 2000)
          // console.log(localStorage.getItem('sessionToken'), localStorage.getItem('conversationId'));
      /*------------------------------------*/
          /*END CONVERSATION START*/
      /*------------------------------------*/
  }


  startChat() {
    this.scrollToBottom();
      this.setState({alreadySeenIntro: false, forceIntro: false}, () => {
          this.forceUpdate();
      })
      document.location.pathName = '?userMessage=Bonjour';
  }

  render() {
    const {
      messages,
      conversationId,
      sessionToken,
      sendMessage,
      activeQuickReply,
      isBotTyping,
      // isFetchingIpAddress,
    } = this.props;

    if (window.location.href.match(/http:/) && !window.location.href.match(/local/)) {
      window.location.href = window.location.href.replace(/^http:/, 'https:')
    }

    if (this.state.alreadySeenIntro === false) {
        return (null)
    } else {
        return (
            <div style={{ height: '100%', margin: '0' }}>
                {/*
                    isFetchingIpAddress &&
                    <div className="fullPage">
                      <h3>{'Indentification de l\'ordinateur'}</h3>
                    </div>
                */}
              <Grid centered stackable style={{ height: '100%', margin: '0' }}>
                <Grid.Column id="inputUser" style={{ width: '90%', height: '100vh', paddingTop: '5vh', overflow: 'hidden'}}>
                  <div style={{ height: '100%' }}>
                    <Grid.Row className="header-wrapper" style={{backgroundColor: 'white', padding: '20px'}}>
                      <Grid.Column className="head-title">
                        <div className="bot-character-updated" style={{ backgroundImage: `url(${profilPic})`}}>
                        </div>
                        <div className="bot-description">
                          <h2 className="title">Arthur, votre formateur virtuel</h2>
                          {/*<p className="tagline">
                              Bonjour ! Je vous ai préparé un super entraînement pour pitcher votre projet ☺️
                          </p>*/}
                        </div>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row
                        className="chat-container"
                        style={{
                            textAlign: 'center',
                            margin: 'auto',
                            height: 'calc(100% - 217px)',
                        }}
                    >
                      <div
                          ref={(el) => { this.secondRow = el }}
                          id="secondRow"
                          style={{ overflowY: 'scroll', height: '100%' }}
                      >
                        <ChatHistory messages={messages} isBotTyping={isBotTyping} secondRow={this.state.secondRow} />
                          { activeQuickReply &&
                          <QuickReplyBanner choices={activeQuickReply} />
                          }
                        <br />
                      </div>
                    </Grid.Row>
                    <Grid.Row style={{ textAlign: 'center', margin: 'auto' }}>
                      <div className="input-manual-custom" style={{ backgroundColor: 'white', marginTop: 10, width: '100%', height: '60px' }}>
                        <UserInput
                            initialValues={{ sessionToken, conversationId }}
                            sendMessage={sendMessage}
                        />
                      </div>
                    </Grid.Row>
                  </div>
                </Grid.Column>
              </Grid>
              <ReduxToastr />
            </div>
        )
    }
  }
}

App.propTypes = {
  messages: PropTypes.array.isRequired,
  conversationId: PropTypes.string,
  sessionToken: PropTypes.string,
  sendMessage: PropTypes.func.isRequired,
  // activeQuickReply: PropTypes.object,
  // activeQuickReply: PropTypes.bool.isRequired,
  // watermark: PropTypes.number.isRequired,
  watermark: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  isBotTyping: PropTypes.bool.isRequired,
  isFetchingIpAddress: PropTypes.bool.isRequired,
  activeGif: PropTypes.string.isRequired,
  userId: PropTypes.string,
  ipAddress: PropTypes.string.isRequired,
}


const mapStateToProps = state => ({
  messages: getMessages(state),
  activeQuickReply: getActiveQuickReply(state),
  isBotTyping: isBotTyping(state),
  conversationId: state.global.get('config').toJS().conversationId,
  sessionToken: state.global.get('config').toJS().sessionToken,
  watermark: state.global.get('watermark'),
  isFetchingIpAddress: state.global.get('ip', Map({})).toJS().fetching,
  activeGif: activeGifSelector(state),
})

const ConnectedApp = connect(
    state => ({ userId: getUserId(state), ipAddress: getIpAddress(state) }),
    null,
)(App);

export default connect(
  mapStateToProps,
  operations,
)(ConnectedApp)



// WEBPACK FOOTER //
// ./src/views/layouts/App.js